import { twMerge } from 'tailwind-merge';
import type { ArrowIconDirection } from './ArrowIcon/types/arrow-icon-direction';
import { ARROW_ICON_DIRECTIONS } from './ArrowIcon/types/arrow-icon-direction';

type TableSortArrowIconProps = {  
  direction: Exclude<ArrowIconDirection, 'left' | 'right'>
  className?: string
};

export const TableSortArrowIcon: React.FC<TableSortArrowIconProps> = ({ direction, className: externalClassName }) => {
  const rotateClassName = getRotateClassName(direction);
  const className = twMerge(externalClassName, rotateClassName);

  return (
    <svg
      width="9"
      height="13"
      viewBox="0 0 9 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.0303 0.359574C4.8839 0.220461 4.69195 0.15088 4.5 0.150879C4.30805 0.150879 4.1161 0.22046 3.96965 0.359574L0.219675 3.92173C-0.0732233 4.19991 -0.0732234 4.65102 0.219675 4.92924C0.512574 5.20742 0.98747 5.20742 1.28032 4.92924L3.75001 2.58326L3.75 11.4384C3.75 11.8319 4.0858 12.1509 4.5 12.1509C4.9142 12.1509 5.25 11.8319 5.25 11.4384L5.25 2.58326L7.71968 4.92925C8.01258 5.20743 8.48743 5.20743 8.78033 4.92925C9.07323 4.65106 9.07323 4.19995 8.78033 3.92173L5.0303 0.359574Z"
        fill="#458FFF"
      />
    </svg>
  );
};

function getRotateClassName(direction: ArrowIconDirection): string {
  switch (direction) {
    case ARROW_ICON_DIRECTIONS.UP:
      return 'rotate-180';                        
    case ARROW_ICON_DIRECTIONS.DOWN:
    default:
      return '';
  }
}